import { useDisplaySettings } from '@src/providers/AppConfigProvider';
import { FEES_ICON, FIRM_LIQUIDITY_ICON } from '@src/tokens/displaySettings';
import { FEES_TOGGLE, FIRM_LIQUIDITY_TOGGLE } from '@src/tokens/tooltips';
import { HStack, Icon, ICON_SIZES, isMultileg, Tooltip, type Security } from '@talos/kyoko';

const TOOLTIP_TARGET_STYLE = { display: 'flex' };

/** Fees / Firm Liquidity badges for a market card header. Firm liquidity is dropped for multileg. */
export function MarketCardDisplayLabels({ security }: { security?: Security }) {
  const { showAllInPrices, showFirmLiquidity } = useDisplaySettings();
  const badges = [
    { key: 'fees', icon: FEES_ICON, name: 'Fees', tooltip: FEES_TOGGLE, show: !!showAllInPrices },
    {
      key: 'firm',
      icon: FIRM_LIQUIDITY_ICON,
      name: 'Firm Liquidity',
      tooltip: FIRM_LIQUIDITY_TOGGLE,
      show: showFirmLiquidity && !isMultileg(security),
    },
  ].filter(badge => badge.show);

  return (
    <HStack gap="spacing4" data-testid="market-card-display-labels">
      {badges.map(({ key, icon, name, tooltip }) => (
        <Tooltip key={key} tooltip={tooltip} targetStyle={TOOLTIP_TARGET_STYLE}>
          <HStack
            p="spacing2"
            lineHeight={1}
            background="primary.default"
            color="white.default"
            borderRadius="borderRadiusDefault"
            aria-label={name}
            data-testid={`market-card-display-label-${key}`}
          >
            <Icon icon={icon} size={ICON_SIZES.SMALL} />
          </HStack>
        </Tooltip>
      ))}
    </HStack>
  );
}
